export class AddFolderReqVm {
  UserID: string;
  FolderName: string;
  DatabaseID: number;
  OrganizationID: number;
  OfficeID: number;
  TemplateID: number = 0;
  transactionID: number;
  folderID: number;
}
